module.exports = __webpack_public_path__ + "img/doc2.8a24727d.svg";